import degreesConfig from "@2u-landing-pages/constants/configs/degrees.json";

const programConfigs = degreesConfig.programs.den;

export const den = {
  slug: "den",
  name: "University of Denver",
  colors: {
    primary1: "#fff",
    text: "#000",
  },
  fonts: {
    base: "Neue Haas Unica, sans-serif",
    url: "https://whitelabel.2u.com/cdn/v1/58de9f26-550b-4221-92e5-15514f2edc3d/marketing/whitelabel.fonts.min.css?ver=1.0",
  },
  programConfigs,
};

